<div class="flex flex-column">
  <p i18n="@@forms.sinister.text.fill_form">
    Por favor rellene el formulario con los datos relacionados con el siniestro.
  </p>

  <div class="mt-4 page">
    <form [formGroup]="sinisterForm">
      <p-fieldset
        i18n-legend="@@forms.sinister.legend.sinister_info"
        legend="Información del accidentado"
        styleClass="mt-4">
        <div class="flex grid m-0 align-items-center">
          <ls-form-field-molecule
            formName="name"
            class="col-12 md:col-6 lg:col-4"
            i18n-labelText="@@forms.sinister.field.fullname"
            labelText="Nombre completo"
            labelFor="name"
            [required]="true"
            [group]="sinisterForm">
          </ls-form-field-molecule>

          <ls-form-field-molecule
            formName="age"
            class="col-12 md:col-6 lg:col-4"
            i18n-labelText="@@forms.sinister.field.age"
            labelText="Edad"
            labelFor="age"
            [required]="true"
            [group]="sinisterForm">
          </ls-form-field-molecule>

          <div class="col-12 md:col-6 lg:col-4">
            <div class="flex flex-column gap-2 field">
              <ls-label-atom
                for="accidente_date"
                i18n-text="@@forms.sinister.field.sinister_date"
                text="Fecha del accidente"
                [required]="true">
              </ls-label-atom>

              <!-- [defaultDate]="defaultDate" -->
              <p-calendar
                formControlName="accident_date"
                [iconDisplay]="'input'"
                [showIcon]="true"
                [showButtonBar]="true"
                [readonlyInput]="true"
                [required]="true"
                styleClass="w-full">
                <ng-template pTemplate="inputicon">
                  <i class="ph ph-calendar-blank pointer-events-none"></i>
                </ng-template>
              </p-calendar>
            </div>
          </div>

          <ls-form-field-molecule
            formName="telephone"
            class="col-12 md:col-6 lg:col-4"
            i18n-labelText="@@forms.sinister.field.mobile"
            labelText="Móvil"
            labelFor="telephone"
            [required]="true"
            [group]="sinisterForm">
          </ls-form-field-molecule>

          <ls-form-field-molecule
            formName="email"
            class="col-12 md:col-6 lg:col-4"
            i18n-labelText="@@forms.sinister.field.email"
            labelText="EMail"
            labelFor="email"
            [group]="sinisterForm"
            [required]="true">
          </ls-form-field-molecule>

          <ls-form-field-molecule
            formName="nif"
            class="col-12 md:col-6 lg:col-4"
            i18n-labelText="@@forms.sinister.field.nif"
            labelText="DNI"
            labelFor="nif"
            [required]="true"
            [group]="sinisterForm">
          </ls-form-field-molecule>

          <ls-form-field-molecule
            formName="diving_center_name"
            class="col-12 md:col-6 lg:col-4"
            i18n-labelText="@@forms.sinister.field.diving_center_name"
            labelText="Nombre del Centro de Buceo"
            labelFor="diving_center_name"
            [group]="sinisterForm"
            [required]="true">
          </ls-form-field-molecule>

          <ls-form-field-molecule
            formName="diver_certification"
            class="col-12 md:col-6 lg:col-4"
            i18n-labelText="@@forms.sinister.field.dive_certification"
            labelText="Certificación/Cualificación del buceador"
            labelFor="diver_certification"
            [group]="sinisterForm"
            [required]="true">
          </ls-form-field-molecule>

          <div class="checkbox col-12">
            <app-input-switch-molecule
              [form]="sinisterForm"
              name="open_water_course"
              class="flex align-items-center justify-content-start flex-wrap w-full"
              i18n-label="@@forms.sinister.field.open_water_course"
              label="Bautizo de mar/curso de Open Water Diver"
              classLabel="text-lg mb-1 mr-3" />
          </div>
        </div>
      </p-fieldset>

      <!-- ---------------------------------------------------------------  -->
      <!-- SINTOMAS -->
      <!-- ---------------------------------------------------------------  -->

      <p-fieldset
        i18n-legend="@@forms.sinister.legend.symptoms"
        legend="Síntomas"
        styleClass="mt-4">
        <div *ngIf="sinisterForm?.hasError('symptomsSelected')">
          <span
            i18n="@@forms.sinister.text.select_options"
            class="p-error block ml-2"
            >(Seleccionar una o más opciones)</span
          >
        </div>

        <div class="flex grid m-0 align-items-center">
          <div class="checkbox col-12 md:col-6 lg:col-4">
            <app-input-switch-molecule
              [form]="sinisterForm"
              name="ear_pain"
              class="flex align-items-center justify-content-start flex-wrap w-full"
              i18n-label="@@forms.sinister.field.ear_pain"
              label="Dolor / molestia en oídos"
              classLabel="text-lg mb-1 mr-3" />
          </div>

          <div class="checkbox col-12 md:col-6 lg:col-4">
            <app-input-switch-molecule
              [form]="sinisterForm"
              name="headache"
              class="flex align-items-center justify-content-start flex-wrap w-full"
              i18n-label="@@forms.sinister.field.headache"
              label="Dolor de cabeza"
              classLabel="text-lg mb-1 mr-3" />
          </div>

          <div class="checkbox col-12 md:col-6 lg:col-4">
            <app-input-switch-molecule
              [form]="sinisterForm"
              name="falls"
              class="flex align-items-center justify-content-start flex-wrap w-full"
              i18n-label="@@forms.sinister.field.falls"
              label="Caídas / golpes"
              classLabel="text-lg mb-1 mr-3" />
          </div>

          <div class="checkbox col-12 md:col-6 lg:col-4">
            <app-input-switch-molecule
              [form]="sinisterForm"
              name="seasickness"
              class="flex align-items-center justify-content-start flex-wrap w-full"
              i18n-label="@@forms.sinister.field.seasickness"
              label="Mareos"
              classLabel="text-lg mb-1 mr-3" />
          </div>

          <div class="checkbox col-12 md:col-6 lg:col-4">
            <app-input-switch-molecule
              [form]="sinisterForm"
              name="joint_pain"
              class="flex align-items-center justify-content-start flex-wrap w-full"
              i18n-label="@@forms.sinister.field.joint_pain"
              label="Dolor en articulaciones"
              classLabel="text-lg mb-1 mr-3" />
          </div>

          <div class="checkbox col-12 md:col-6 lg:col-4">
            <app-input-switch-molecule
              [form]="sinisterForm"
              name="skin_spots"
              class="flex align-items-center justify-content-start flex-wrap w-full"
              i18n-label="@@forms.sinister.field.skin_spots"
              label="Manchas cutáneas"
              classLabel="text-lg mb-1 mr-3" />
          </div>

          <div class="checkbox col-12 md:col-6 lg:col-4">
            <app-input-switch-molecule
              [form]="sinisterForm"
              name="nausea"
              class="flex align-items-center justify-content-start flex-wrap w-full"
              i18n-label="@@forms.sinister.field.nausea"
              label="Náuseas"
              classLabel="text-lg mb-1 mr-3" />
          </div>

          <div class="checkbox col-12 md:col-6 lg:col-4">
            <app-input-switch-molecule
              [form]="sinisterForm"
              name="limbs_numbness"
              class="flex align-items-center justify-content-start flex-wrap w-full"
              i18n-label="@@forms.sinister.field.limbs_numbness"
              label="Adormecimiento de miembros"
              classLabel="text-lg mb-1 mr-3" />
          </div>

          <div class="checkbox col-12 md:col-6 lg:col-4">
            <app-input-switch-molecule
              [form]="sinisterForm"
              name="extreme_fatigue"
              class="flex align-items-center justify-content-start flex-wrap w-full"
              i18n-label="@@forms.sinister.field.extreme_fatigue"
              label="Cansancio extremo"
              classLabel="text-lg mb-1 mr-3" />
          </div>

          <div class="checkbox col-12 md:col-6 lg:col-4">
            <app-input-switch-molecule
              [form]="sinisterForm"
              name="vertigo"
              class="flex align-items-center justify-content-start flex-wrap w-full"
              i18n-label="@@forms.sinister.field.vertigo"
              label="Vértigo"
              classLabel="text-lg mb-1 mr-3" />
          </div>

          <div class="checkbox col-12 md:col-6 lg:col-4">
            <app-input-switch-molecule
              [form]="sinisterForm"
              name="limbs_tingling"
              class="flex align-items-center justify-content-start flex-wrap w-full"
              i18n-label="@@forms.sinister.field.limbs_tingling"
              label="Hormigueo en miembros"
              classLabel="text-lg mb-1 mr-3" />
          </div>

          <div class="checkbox col-12 md:col-6 lg:col-4">
            <app-input-switch-molecule
              [form]="sinisterForm"
              name="semi_drowning"
              class="flex align-items-center justify-content-start flex-wrap w-full"
              i18n-label="@@forms.sinister.field.semi_drowning"
              label="Semi ahogamiento"
              classLabel="text-lg mb-1 mr-3" />
          </div>
        </div>
      </p-fieldset>

      <!-- ---------------------------------------------------------------- -->
      <!-- Detalles de la inmersion -->
      <!-- ---------------------------------------------------------------- -->

      <p-fieldset
        i18n-legend="@@forms.sinister.legend.diving_details"
        legend="Detalles de la inmersion"
        styleClass="mt-4">
        <div class="flex flex-wrap grid m-0 align-items-center">
          <ls-form-field-molecule
            formName="max_depth"
            class="col-12 md:col-6"
            i18n-labelText="@@forms.sinister.field.max_depth"
            labelText="Profundidad máxima"
            labelFor="max_depth"
            [required]="true"
            [group]="sinisterForm">
          </ls-form-field-molecule>

          <ls-form-field-molecule
            formName="total_immersion_time"
            class="col-12 md:col-6"
            i18n-labelText="@@forms.sinister.field.total_immersion_time"
            labelText="Tiempo total de la inmersión"
            labelFor="total_immersion_time"
            [required]="true"
            [group]="sinisterForm">
          </ls-form-field-molecule>

          <div class="checkbox col-12 md:col-6 lg:col-6">
            <app-input-switch-molecule
              [form]="sinisterForm"
              name="stop_decompression_omission"
              class="flex align-items-center justify-content-start flex-wrap w-full"
              i18n-label="@@forms.sinister.field.stop_decompression_omi"
              label="Omisión parada de descompresión"
              classLabel="text-lg mb-1 mr-3" />
          </div>

          <div class="checkbox col-12 md:col-6 lg:col-3">
            <app-input-switch-molecule
              [form]="sinisterForm"
              name="quick_ascent"
              class="flex align-items-center justify-content-start flex-wrap w-full"
              i18n-label="@@forms.sinister.field.quick_ascent"
              label="Ascenso rápido"
              classLabel="text-lg mb-1 mr-3" />
          </div>

          <div class="checkbox col-12 md:col-6 lg:col-3">
            <app-input-switch-molecule
              [form]="sinisterForm"
              name="panic"
              class="flex align-items-center justify-content-start flex-wrap w-full"
              i18n-label="@@forms.sinister.field.panic"
              label="Pánico"
              classLabel="text-lg mb-1 mr-3" />
          </div>

          <div class="col-12">
            <p-divider></p-divider>
            <p><b i18n="@@forms.sinister.text.dive_with">Buceo con *</b></p>
            <div *ngIf="sinisterForm?.hasError('divingWithSelected')">
              <span
                class="p-error block"
                i18n="@@forms.sinister.text.select_options"
                >(Seleccionar una o más opciones)</span
              >
            </div>
          </div>
          <div class="flex flex-wrap col-12 gap-4">
            <!-- [(ngModel)]="value" -->
            <!-- <p-selectButton
              [options]="[
                { label: 'Aire', value: 'aire' },
                { label: 'Nitrox', value: 'nitrox' },
                { label: 'Trimix', value: 'trimix' },
                { label: 'Rebreather', value: 'rebreather' }
              ]"
              formControlName="diving_with"
              [multiple]="true"
              optionLabel="label"
              optionValue="value" /> -->

            <div class="checkbox">
              <app-input-switch-molecule
                [form]="sinisterForm"
                name="diving_air"
                class="flex align-items-center justify-content-start flex-wrap w-full"
                i18n-label="@@forms.sinister.field.diving_air"
                label="Aire"
                classLabel="text-lg mb-1 mr-3" />
            </div>

            <div class="checkbox">
              <app-input-switch-molecule
                [form]="sinisterForm"
                name="diving_nitrox"
                class="flex align-items-center justify-content-start flex-wrap w-full"
                i18n-label="@@forms.sinister.field.diving_nitrox"
                label="Nitrox"
                classLabel="text-lg mb-1 mr-3" />
            </div>

            <div class="checkbox">
              <app-input-switch-molecule
                [form]="sinisterForm"
                name="diving_trimix"
                class="flex align-items-center justify-content-start flex-wrap w-full"
                i18n-label="@@forms.sinister.field.diving_trimix"
                label="Trimix"
                classLabel="text-lg mb-1 mr-3" />
            </div>

            <div class="checkbox">
              <app-input-switch-molecule
                [form]="sinisterForm"
                name="diving_rebreather"
                class="flex align-items-center justify-content-start flex-wrap w-full"
                i18n-label="@@forms.sinister.field.diving_rebreather"
                label="Rebreather"
                classLabel="text-lg mb-1 mr-3" />
            </div>
          </div>

          <div class="col-12">
            <p-divider></p-divider>
            <p><b i18n="@@forms.sinister.text.dive_type">Tipo de buceo *</b></p>
            <div *ngIf="sinisterForm?.hasError('divingTypeSelected')">
              <span
                class="p-error block ml-2"
                i18n="@@forms.sinister.text.select_options"
                >(Seleccionar una o más opciones)</span
              >
            </div>
          </div>

          <div class="flex flex-wrap col-12 gap-4">
            <!-- <p-selectButton
              [options]="[
                { label: 'Primera inmersión', value: 'first_dive' },
                { label: 'Sucesiva', value: 'successive' }
              ]"
              formControlName="diving_type"
              [multiple]="true"
              optionLabel="label"
              optionValue="value" /> -->

            <div class="checkbox">
              <app-input-switch-molecule
                [form]="sinisterForm"
                name="diving_type_first_dive"
                class="flex align-items-center justify-content-start flex-wrap w-full"
                i18n-label="@@forms.sinister.field.diving_type_first_dive"
                label="Primera inmersión"
                classLabel="text-lg mb-1 mr-3" />
            </div>

            <div class="checkbox">
              <app-input-switch-molecule
                [form]="sinisterForm"
                name="diving_type_successive"
                class="flex align-items-center justify-content-start flex-wrap w-full"
                i18n-label="@@forms.sinister.field.diving_type_successive"
                label="Sucesiva"
                classLabel="text-lg mb-1 mr-3" />
            </div>
          </div>

          <div class="col-12">
            <p-divider></p-divider>
          </div>

          <div class="col-12">
            <div class="checkbox">
              <app-input-switch-molecule
                [form]="sinisterForm"
                name="equipment_failure"
                class="flex align-items-center justify-content-start flex-wrap w-full"
                i18n-label="@@forms.sinister.field.equipment_failure"
                label="Fallo del equipo"
                classLabel="text-lg mb-1 mr-3" />
            </div>
          </div>

          <div class="checkbox col-12 md:col-6 lg:col-4">
            <app-input-switch-molecule
              [form]="sinisterForm"
              name="course_attending"
              class="flex align-items-center justify-content-start flex-wrap w-full"
              i18n-label="@@forms.sinister.field.course_attending"
              label="¿Atendía a un curso de buceo?"
              classLabel="text-lg mb-1 mr-3" />
          </div>

          <ls-form-field-molecule
            formName="course_attending_name"
            class="col-12 md:col-6"
            labelText="Si la respuesta es afirmativa cuál era el curso"
            labelFor="course_attending_name"
            [required]="false"
            [group]="sinisterForm">
          </ls-form-field-molecule>
        </div>
      </p-fieldset>

      <!-- ---------------------------------------------------------------- -->
      <!-- Documentos necesarios para la tramitación -->
      <!-- ---------------------------------------------------------------- -->

      <p-fieldset
        i18n-legend="@@forms.sinister.legend.claim_necessary_documents"
        legend="Documentos necesarios para la tramitación"
        styleClass="mt-4">
        <div class="grid">
          <div class="col-12 md:col-6">
            <p>
              <b i18n="@@forms.sinister.text.refund_case"
                >En caso de reembolso de gastos incurridos </b
              ><br />
              <!-- (Marcar para subir el archivo) -->
            </p>

            <div class="col-12">
              <p i18n="@@forms.sinister.text.medical_report">Informe médico</p>
              <p i18n="@@forms.sinister.text.invoices">Facturas</p>
              <p i18n="@@forms.sinister.text.bank_account_certificate">
                Certificado de cuenta bancaria
              </p>
            </div>

            <!-- <div class="checkbox col-12">
              <app-input-switch-molecule
                [form]="sinisterForm"
                name="medical_report"
                class="flex align-items-center justify-content-start flex-wrap w-full"
                label="Informe médico"
                classLabel="text-lg mb-1 mr-3" />

            </div>

            <div class="checkbox col-12">
              <app-input-switch-molecule
                [form]="sinisterForm"
                name="bills"
                class="flex align-items-center justify-content-start flex-wrap w-full"
                label="Facturas"
                classLabel="text-lg mb-1 mr-3" />

            </div>

            <div class="checkbox col-12">
              <app-input-switch-molecule
                [form]="sinisterForm"
                name="bank_account_certificate"
                class="flex align-items-center justify-content-start flex-wrap w-full"
                label="Certificado de cuenta bancaria"
                classLabel="text-lg mb-1 mr-3" />

            </div> -->
          </div>
          <div class="col-12 md:col-6">
            <p>
              <b i18n="@@forms.sinister.text.hospital_or_hiperbaric_chamber">
                En caso de necesitar hospitalización o tratamiento en cámara
                hiperbárica
              </b>
            </p>
            <p i18n="@@forms.sinister.text.medical_report">Informe médico</p>
            <p i18n="@@forms.sinister.text.prescribed_treatment">
              Tratamiento prescrito
            </p>
            <p i18n="@@forms.sinister.text.treatment_budget">
              Presupuesto coste del tratamiento
            </p>
            <p i18n="@@forms.sinister.text.medical_center_name">
              Nombre del centro médico
            </p>
          </div>
        </div>
      </p-fieldset>

      <div class="mt-4">
        <p>
          <span i18n="@@forms.sinister.text.send_documentation_to"
            >La documentación enviarla al email</span
          >
          <a href="mailto:admin&#64;restaurantedonchon.com">admin&#64;restaurantedonchon.com</a>
        </p>
        <p i18n="@@forms.sinister.text.any_query_contact_to">
          Para cualquier consulta ponerse en contacto en el teléfono 971 693 930
        </p>
        <p></p>
        <p>
          <strong i18n="@@forms.sinister.text.important">IMPORTANTE</strong>
        </p>
        <p>
          <strong i18n="@@forms.sinister.text.sinister_declaration_must_notify"
            >LA PRESENTE DECLARACIÓN DE SINIESTROS DEBE SER REMITIDA AL
            TRAMITADOR DEL SINIESTRO COMO MÁXIMO 30 DÍAS DESPUÉS DEL
            ACCIDENTE.</strong
          >
        </p>
        <p>
          <strong i18n="@@forms.sinister.text.any_pending_documentation"
            >Cualquier documentación faltante la podrán añadir luego del envío
            de la presente declaración.</strong
          >
        </p>
      </div>
    </form>
  </div>

  <p-divider></p-divider>

  <div class="flex flex-wrap justify-content-end gap-2 mt-4">
    <p-button
      i18n-label="@@forms.sinister.button.cancel"
      label="Cancelar"
      severity="secondary"
      (onClick)="closeDialog()" />

    <p-button
      i18n-label="@@forms.sinister.button.send"
      label="Enviar"
      (onClick)="sendForm()" />

    <!-- <p-button label="PDF" (onClick)="sinisterFormToPDF()" /> -->
    <!-- [disabled]="sinisterForm.invalid"  -->
  </div>
</div>
